import { CloseIcon } from "@/assets/icons";
import { capitalizeEachWord } from "@/helpers/string";
import { cn } from "@/lib/utils";

export type ChipAttribute = {
  id: string;
  key: string;
  value: string;
};

interface ChipProps {
  chip: ChipAttribute;
  onDelete: (id: string) => void;
  onEdit: (chip: ChipAttribute) => void;
}

const Chip = ({ chip, onDelete, onEdit }: ChipProps) => (
  <button
    className={cn(
      "inline-flex items-center space-x-1 px-2 py-1 font-medium rounded-lg border",
      "bg-whisper text-dim-gray border-gainsboro",
      "transition duration-150 font-semibold text-xs ease-in-out select-none flex-shrink-0",
      "cursor-pointer hover:bg-gray-100 hover:border-gray-300"
    )}
    onClick={() => onEdit(chip)}
    aria-label={`Edit chip ${chip.key}:${chip.value}`}
  >
    <span>{capitalizeEachWord(chip.key, "_")}:</span>
    <span>{chip.value}</span>
    <button
      onClick={(e) => {
        e.stopPropagation();
        onDelete(chip.id);
      }}
      className="text-gray-500 hover:text-gray-900 rounded-full p-0.5 transition-colors duration-150"
      aria-label={`Remove chip ${chip.key}:${chip.value}`}
    >
      <CloseIcon className="h-3 w-3" />
    </button>
  </button>
);

export default Chip;
